import { AlertTriangle, Check } from "lucide-react";

export interface IntegrationEntitlementSnapshot {
  sdkHandoffAllowed: boolean;
  state: "active" | "trialing" | "past_due" | "canceled" | "unpaid" | "incomplete";
  allowedBusinessIdentityCount: number;
  assignedBusinessIdentityCount: number;
  workspaceEntitled: boolean;
  overBusinessIdentityLimit: boolean;
  blockedReasons: string[];
  recoveryCta: "none" | "complete-payment" | "update-payment" | "restart-checkout" | "contact-support";
}

const ctaLabels: Record<IntegrationEntitlementSnapshot["recoveryCta"], string> = {
  none: "Ready",
  "complete-payment": "Complete payment",
  "update-payment": "Update payment",
  "restart-checkout": "Restart checkout",
  "contact-support": "Contact support",
};

export function IntegrationEntitlementGate({ entitlement }: { entitlement: IntegrationEntitlementSnapshot }) {
  return <section className="integration-entitlement-gate" aria-label="Subscription entitlements">
    <h4>{entitlement.sdkHandoffAllowed ? "Subscription entitlements ready" : "Subscription entitlements blocked"}</h4>
    <dl>
      <div><dt>Subscription</dt><dd>{entitlement.state}</dd></div>
      <div><dt>Business @ identities</dt><dd>{entitlement.assignedBusinessIdentityCount} of {entitlement.allowedBusinessIdentityCount}</dd></div>
      <div><dt>Workspace</dt><dd>{entitlement.workspaceEntitled ? "Entitled" : "Not entitled"}</dd></div>
    </dl>
    {entitlement.sdkHandoffAllowed ? <p role="status"><Check size={15} aria-hidden="true" /> SDK handoff can be shown.</p> :
      <div role="alert"><AlertTriangle size={16} aria-hidden="true" /><span>SDK handoff is blocked before customer recovery completes.</span></div>}
    {entitlement.blockedReasons.length ? <ul>{entitlement.blockedReasons.map(reason => <li key={reason}>{reason}</li>)}</ul> : null}
    <button type="button" className="portal-button" disabled={entitlement.recoveryCta === "none"}>{ctaLabels[entitlement.recoveryCta]}</button>
  </section>;
}
